import Vue from 'vue'
import App from './App.vue'
import router from './router'
import configuration from './configuration.js'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueGtm from 'vue-gtm'

Vue.config.productionTip = false

Vue.use(VueAxios, axios);
Vue.use(VueGtm, {
	id: "GTM-K2MMQTW"
});

Vue.axios.defaults.baseURL = process.env.VUE_APP_SERVER_URL;

new Vue({
  router,
  render: h => h(App),
    data: configuration
}).$mount('#app')
